const pageContentType = 'PAGE_CONTENT';
const pageContentClassType = 'PAGE_CONTENT_CLASS';
const pageContentFullHeightType = 'PAGE_CONTENT_FULL_HEIGHT'; 
const pageContentFullWidthType = 'PAGE_CONTENT_FULL_WIDTH';

const initialState = {
    pageContent: true,
    pageContentClass: '',
    pageContentFullHeight: false,
    pageContentFullWidth: false
};

export const actionCreators = {
    handleSetPageContent: () => ({ type: pageContentType }),
    handleSetPageContentClass: () => ({ type: pageContentClassType }),
    handleSetPageContentFullHeight: () => ({ type: pageContentFullHeightType }),
    handleSetPageContentFullWidth: () => ({ type: pageContentFullWidthType }),
};

export const reducer = (state, action) => {
    state = state || initialState;

    //console.log(state);

    switch (action.type) {
        case pageContentType:
            return { ...state, pageContent: !state.pageContent };

        case pageContentClassType:
            return { ...state, pageContentClass: state.pageContentClass ? '' : '' };

        case pageContentFullHeightType:
            return { ...state, pageContentFullHeight: !state.pageContentFullHeight };

        case pageContentFullWidthType:
            return { ...state, pageContentFullWidth: !state.pageContentFullWidth };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/store/admin/content.js